/**
 * useLocalePath — builds locale-prefixed paths.
 *
 * Usage:
 *   const lp = useLocalePath();
 *   lp('/dashboard')        → '/en/dashboard'
 *   lp('/business/profile/slug') → '/he/business/profile/slug'
 *
 * The returned function is memoized (changes only when `lang` changes) so it is
 * safe to list `lp` in useEffect dependency arrays — avoids infinite re-fetch loops.
 */
import { useCallback } from "react";
import { useTranslation } from "../i18n/I18nContext";

export function useLocalePath() {
  const { lang } = useTranslation();
  return useCallback((path) => {
    const clean = path.startsWith("/") ? path : `/${path}`;
    return `/${lang}${clean}`;
  }, [lang]);
}
